<template>
	<b-modal
		ref="sons-with-incidences-modal"
		size="xmd"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Hijos con incidencias</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="specimens.length > 0">
						<b-tr v-for="(draft, index) in specimens" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="draft.padrillo" show_status show_details_icon />
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate :specimen="draft.madrilla" show_status show_details_icon />
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate :specimen="draft.specimen" show_status show_details_icon />
							</b-td>
							<b-td class="text-center">
								<div class="position-relative">
									<feather-icon
										@click="openIncidenceModal(draft.specimen)"
										v-b-tooltip.hover="'Ver incidencias'"
										:class="{
											'icon-disabled': draft.specimen.incidences_qty === 0,
										}"
										class="text-primary"
										icon="AlertOctagonIcon"
										size="19"
										style="cursor: pointer"
									/>
									<span v-if="draft.specimen.incidences_qty > 0" class="incidences-counter">
										{{ draft.specimen.incidences_qty }}
									</span>
								</div>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="specimens.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<SpecimenIncidencesModal
			v-if="incidenceModal.show"
			:show="incidenceModal.show"
			:info="incidenceModal.info"
			@closing="incidenceModal.show = false"
		/>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenService from "@/services/specimens.service.js"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
export default {
	name: "SonsWithIncidencesModal",
	props: {
		specimen: {
			type: Object,
			required: true,
		},
	},
	components: {
		SpecimenPlate,
		SpecimenIncidencesModal,
	},
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "padrillo", label: "PADRILLO", class: "text-center" },
			{ key: "madrilla", label: "MADRILLA", class: "text-center" },
			{ key: "son", label: "HIJO", class: "text-center" },
			{ key: "incidence", label: "INCIDENCIA", class: "text-center" },
		],
		specimens: [],
		incidenceModal: {
			show: false,
			info: null,
		},
	}),
	methods: {
		openIncidenceModal(item) {
			this.incidenceModal.info = item
			this.incidenceModal.show = true
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await SpecimenService.getSonsWithIncidences(this.specimen.id)
				this.specimens = data
			} catch (error) {
				console.error("Error fetching average weights report specimens:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["sons-with-incidences-modal"].toggle()
		this.getRows()
	},
}
</script>
<style lang="scss" scoped>
.incidences-counter {
	position: absolute;
	top: -0.4rem;
	right: 3rem;
	height: 1.2rem;
	min-width: 1.2rem;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	background: var(--primary);
	border-radius: 0.2rem;
	font-weight: bolder;
	font-size: 12px;
}
.icon-disabled {
	pointer-events: none;
	opacity: 0.5;
}
</style>
